﻿import { setVisibility } from "../helpers";
export function initVolledigPage() {
    const berekenForm = document.querySelector('form[action*="CalculateFullRedemption"]');

    if (berekenForm) {

        berekenForm.addEventListener('change', hideLoanPartSelector);
    }
}

function hideLoanPartSelector() {
    const loanPartSelector = document.querySelector('form[action*="LoanPartSelection"]');

    if (loanPartSelector) {
        setVisibility(loanPartSelector, false);
    }
}